import { useState } from 'react';

/**
 * Share links for an article.
 *
 * Plain anchors to each network's intent URL — no third-party share widget, so
 * no extra JavaScript, no tracking script and nothing to slow down LCP. The
 * copy button uses the native Web Share sheet on mobile where it exists.
 */
function ShareRow({ url, title }) {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const targets = [
    { label: 'X', href: `https://x.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}` },
    {
      label: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    { label: 'WhatsApp', href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}` },
  ];

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (_) {
        // Reader dismissed the sheet — fall through to copying instead.
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // Clipboard blocked (insecure context or denied permission).
    }
  };

  return (
    <div className="share-row">
      <span className="share-label">Share</span>
      <ul className="share-list">
        {targets.map((t) => (
          <li key={t.label}>
            {/* nofollow: these are utility links, not editorial endorsements. */}
            <a
              className="btn btn-sm btn-ghost"
              href={t.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {t.label}
            </a>
          </li>
        ))}
        <li>
          <button type="button" className="btn btn-sm btn-ghost" onClick={share}>
            {copied ? 'Link copied' : 'Copy link'}
          </button>
        </li>
      </ul>
    </div>
  );
}

export default ShareRow;
